/**
 * Price Component
 *
 * Centralized currency formatting for consistent price display.
 * Uses shared currencyFormatter for proper thousands separators and decimals.
 *
 * Usage:
 *   <Price amount={99.99} />
 *   <Price amount={1299.00} className="font-bold text-xl" />
 *   <Price amount={-50} />  // Shows -$50.00 for discounts
 *
 * For non-JSX contexts (emails, data processing), use toCurrency() from Util.js
 */

import { currencyFormatter } from '@/app/_lib/config/currency'

const Price = ({ amount, className }) => {
    return (
        <span className={className}>
            {currencyFormatter.format(amount)}
        </span>
    )
}

export default Price
